module.exports = __webpack_public_path__ + "static/media/License_baseColor.bad5ab06.jpeg";